module.exports = __webpack_public_path__ + "assets/11cab56d2577a1f24e9bf2db52176e16.mp4";